var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{ref:"textarea",attrs:{"clearable":_vm.clearable,"label":_vm.label,"loading":_vm.loading,"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"rules":_vm.rules,"auto-grow":true,"rows":1},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }